module.exports = __webpack_public_path__ + "img/reference37.6bbff0fb.jpg";